import Call from '../Call';
import {objToQs} from '../Utils';

const DynamicHourlyCutoff = {
    get(filters) {
        return Call(`dynamicHourlyCutoff?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`dynamicHourlyCutoff/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`dynamicHourlyCutoff/affid`);
    },

    getSubids(filters) {
        return Call(`dynamicHourlyCutoff/subid?${objToQs(filters)}`);
    },

    getSubidsAll(filters) {
        return Call(`dynamicHourlyCutoff/subid/all?${objToQs(filters)}`);
    },
    updateFactor(affid, subid, country, factor) {
        return Call(`dynamicHourlyCutoff/factor`, 'PUT', { affid, subid, country, factor })
    }
}

export default DynamicHourlyCutoff;


// WEBPACK FOOTER //
// ./src/services/API/components/DynamicHourlyCutoff.js